import React, { useEffect, createContext, useContext, useState } from 'react';
import { Routes, Route, useParams, useNavigate } from 'react-router-dom';
import { Layout, Menu, Spin } from 'antd';
import axios from 'axios';
import Home from './pages/Home';
import Support from './pages/Support';
import Bookings from './pages/Bookings';
import FAQ from './pages/FAQ';
import Passengers from './pages/Passengers';
import Landing from './pages/Landing';
import PaymentSuccess from './pages/PaymentSuccess';
import PrivacyPolicy from './pages/PrivacyPolicy';
import {  HomeOutlined, TeamOutlined, TagsOutlined, PhoneOutlined, QuestionCircleOutlined, DashboardOutlined } from '@ant-design/icons';
import Admin from './pages/Admin';
import Drop from './pages/Drop';
const { Header, Content } = Layout;

export const AuthContext = createContext();
export const NavBarContext = createContext();
export const AuthInfoContext = createContext();
export const ConfigContext = createContext();

const DEV_ENDPOINT = 'http://localhost:5051';
const PROD_ENDPOINT = 'https://api.steadyshuttle.com';
const BACKEND_ENDPOINT = process.env.NODE_ENV === 'development' ? DEV_ENDPOINT : PROD_ENDPOINT;




function App() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isNavBarVisible, setIsNavBarVisible] = useState(true);
  const [authFailReason, setAuthFailReason] = useState('');
  const [authInfo, setAuthInfo] = useState({
    cid: localStorage.getItem('cid'),
    session_key: localStorage.getItem('session_key'),
    isAdmin: false,
  });
  const [menuItems, setMenuItems] = useState([
    { key: '1', label: (<><HomeOutlined /></>), path: '/home' },
    { key: '2', label: (<><TeamOutlined /></>), path: '/passengers' },
    { key: '3', label: (<><TagsOutlined /></>), path: '/bookings' },
    { key: '4', label: (<><QuestionCircleOutlined /></>), path: '/faq' },
    { key: '5', label: (<><PhoneOutlined /></>), path: '/support' },
    (authInfo.isAdmin && { key: '6', label: (<><DashboardOutlined/></>), path: '/admin' }),
  ]);

  // KL/ETS supplemental config
  const [appConfig, setAppConfig] = useState({});
  useEffect(() => {
    async function fetchConfig() {
      try {
        const res = await axios.get(`${BACKEND_ENDPOINT}/api/config`);
        if (res.data && res.data.success) {
          const cfg = res.data || {};
          setAppConfig(cfg);
          // In dev, ensure ETS UI is visible for testing regardless of flag
          if (process.env.NODE_ENV === 'development') {
            setAppConfig({ ...cfg, 'kl-enabled': true });
          }
          if (cfg['stripe-pk']) {
            window.__STRIPE_PUBLISHABLE_KEY__ = cfg['stripe-pk'];
          }
        } else {
          if (process.env.NODE_ENV === 'development') setAppConfig({ 'kl-enabled': true });
        }
      } catch (e) {
          if (process.env.NODE_ENV === 'development') setAppConfig({ 'kl-enabled': true });
      }
    }
    fetchConfig();
  }, []);


  // navbar funcs
  const [selectedKey, setSelectedKey] = useState('1');
  const handleMenuSelect = ({ key }) => {
    setSelectedKey(key);
    if (key === '1') {
      navigate('/home');
    } else if (key === '2') {
      navigate('/passengers');
    } else if (key === '3') {
      navigate('/bookings');
    } else if (key === '4') {
      navigate('/faq');
    } else if (key === '5') {
      navigate('/support');
    } else if (key === '6') {
      navigate('/admin');
    }
  };

  useEffect(() => {
    // check if the user is authenticated and update the state accordingly
    const auth = true; // replace with your own authentication logic
    setIsAuthenticated(auth);
    setAuthInfo({
      cid: localStorage.getItem('cid'),
      session_key: localStorage.getItem('session_key'),
      isAdmin: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    const items = [
      { key: '1', label: (<><HomeOutlined /></>), path: '/home' },
      { key: '2', label: (<><TeamOutlined /></>), path: '/passengers' },
      { key: '3', label: (<><TagsOutlined /></>), path: '/bookings' },
    ];
    items.push({ key: '4', label: (<><QuestionCircleOutlined /></>), path: '/faq' });
    items.push({ key: '5', label: (<><PhoneOutlined /></>), path: '/support' });
    if (authInfo.isAdmin) items.push({ key: '6', label: (<><DashboardOutlined/></>), path: '/admin' });
    setMenuItems(items);
  }, [authInfo])

  const toggleNavBarVisibility = (target) => {
    setIsNavBarVisible(target);
  };

  const verifyAuth = () => {
    // console.log("verifying auth..")
    // make a request to the backend to verify the session
    let cid = localStorage.getItem('cid');
    let session_key = localStorage.getItem('session_key');
    axios.post(`${BACKEND_ENDPOINT}/api/auth`, { cid, session_key })
      .then(response => {
        if (response.data.success) {
          console.log("auth ok")
          setAuthInfo({ cid: cid, session_key: session_key, isAdmin: !!response.data.isAdmin });
        } else {
          // retry
          cid = localStorage.getItem('cid');
          session_key = localStorage.getItem('session_key');
          axios.post(`${BACKEND_ENDPOINT}/api/auth`, { cid, session_key })
            .then(response => {
              if (response.data.success) {
                console.log("auth ok")
                setAuthInfo({ cid: cid, session_key: session_key, isAdmin: !!response.data.isAdmin });
              } else {
                setAuthFailReason(response.data.reason)
                navigate('/invalid-session');
              }
          })
        }
      })
      .catch(error => {
        console.log("error", error)
        setAuthFailReason("Networking error, could not connect to verification server")
        navigate('/invalid-session');
      });
  }

  return (
    <AuthContext.Provider value={{isAuthenticated, setIsAuthenticated, authFailReason, setAuthFailReason, verifyAuth}}>
      <NavBarContext.Provider value={{toggleNavBarVisibility, setSelectedKey, selectedKey}}>
        <AuthInfoContext.Provider value={{ authInfo, setAuthInfo }}>
          <ConfigContext.Provider value={{ appConfig }}>
            <Layout>
              <Header style={{ display: isNavBarVisible ? 'block' : 'none' }}>
                <div className="logo" />
                {/* <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>
                  <Menu.Item key="1">Route 1</Menu.Item>
                  <Menu.Item key="2">Route 2</Menu.Item>
                  <Menu.Item key="3">Route 3</Menu.Item>
                </Menu> */}

                <Menu
                  theme="dark"
                  mode="horizontal"
                  items={menuItems}
                  selectedKeys={[selectedKey]}
                  onSelect={handleMenuSelect}
                />
              </Header>
              <Content style={{ padding: 0, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f2f5' }}>
                <div
                  className="site-layout-content"
                  style={{
                    background: '#fff',
                    padding: '24px',
                    borderRadius: '8px',
                    width: '90%',
                    marginTop: '2em',
                    marginBottom: '3em',
                    maxWidth: '1200px',
                  }}
                >
                  {
                    isNavBarVisible &&
                    <>
                    {/* <Alert message="[Update: This issue has been resolved as of 3 July 2024] Due to recent changes in KTMB's booking system, receipt PDFs are not being generated correctly on SteadyShuttle. However, your confirmed bookings remain valid by scanning your passport at the departure gate. We are working on a fix and will update this message once resolved." 
                    closable={false}
                    type="warning" 
                    style={{
                      marginBottom: "2em"
                    }}/> */}
                    </>
                  }
                  <Routes>
                    <Route path="/s/:sess" element={<VerificationComponent />} />
                    <Route exact path="/" element={<Landing />} />
                    <Route path="/invalid-session" element={<InvalidSessionComponent />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/passengers" element={<Passengers />} />
                    <Route path="/bookings" element={<Bookings />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/support" element={<Support />} />
                    <Route path="/admin" element={<Admin/>} />
                    <Route path="/payment-success" element={<PaymentSuccess />} />
                    <Route path='/drop/:dropcode' element={<Drop />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  </Routes>
                </div>
              </Content>
            </Layout>
          </ConfigContext.Provider>
        </AuthInfoContext.Provider>
      </NavBarContext.Provider>
    </AuthContext.Provider>
  );
}

function VerificationComponent() {
  const navigate = useNavigate();
  const { setIsAuthenticated, setAuthFailReason } = useContext(AuthContext);
  const { toggleNavBarVisibility } = useContext(NavBarContext);
  const { setAuthInfo } = useContext(AuthInfoContext);
  const { sess } = useParams();
  const [cid, session_key] = sess.split(':');

  useEffect(() => {
    // if ':' does not exist in sess, redirect to invalid session page
    if (cid === undefined || session_key === undefined) {
      setAuthFailReason("Malformed session key")
      navigate('/invalid-session')
    }
    

    
    // make a request to the backend to verify the session
    axios.post(`${BACKEND_ENDPOINT}/api/auth`, { cid, session_key })
      .then(response => {
        if (response.data.success) {
          // save auth info to local storage
          console.log("auth ok")
          localStorage.setItem('cid', cid);
          localStorage.setItem('session_key', session_key);
          setAuthInfo({ cid: cid, session_key: session_key, isAdmin: !!response.data.isAdmin });
          navigate('/home')
          setIsAuthenticated(true);
        } else {
          setAuthFailReason(response.data.reason)
          navigate('/invalid-session');
        }
      })
      .catch(error => {
        console.log("error", error)
        setAuthFailReason("Networking error, could not connect to verification server")
        navigate('/invalid-session');
        
      });

    
  // navigate, setters are stable from React; dependency list limited to params
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cid, session_key]);

  useEffect(() => {
    // hide navbar in this component
    toggleNavBarVisibility(false);
    return () => {
      toggleNavBarVisibility(true);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        width: '100%',
        padding: '0 16px',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          width: '100%',
          maxWidth: '520px',
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
        }}
      >
        <Spin size="large" className="slow-spin" />
        <h1 style={{ marginTop: '1em', fontSize: 'clamp(20px, 4vw, 28px)' }}>
          Verifying your credentials
        </h1>
        <p style={{ marginTop: '0.5em', color: '#999', fontSize: 'clamp(14px, 3.5vw, 16px)' }}>
          Please wait a moment...
        </p>
      </div>
    </div>
  );
}

function InvalidSessionComponent() {
  const { authFailReason } = useContext(AuthContext);
  const { toggleNavBarVisibility } = useContext(NavBarContext);
  useEffect(() => {
    // hide navbar in this component
    toggleNavBarVisibility(false);
    // delete cid and session_key from local storage
    localStorage.removeItem('cid');
    localStorage.removeItem('session_key');
    return () => {
      // show navbar again when component unmounts
      toggleNavBarVisibility(true);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', width: '100%', padding: '0 16px' }}>
      <div style={{
        textAlign: 'center',
        width: '100%',
        maxWidth: '520px',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
      }}>
        <h1 style={{ fontSize: 'clamp(20px, 4vw, 28px)' }}>Unable to verify credentials</h1>
        {
          authFailReason !== '' &&
            <p>
              Reason: {authFailReason}
            </p>
        }
        <p style={{ fontSize: 'clamp(14px, 3.5vw, 16px)' }}><a href='tg://resolve?domain=SteadyShuttleBot'>You can login again here.</a></p>
      </div>
    </div>
  );
}

export default App;
